import { useCreditInfoStepsContext } from '../../../../context/creditInfoStepsContext';
import { SERVICE_TYPES } from '../../../../utils/constants/fieldErrors';
import SimpleAgreement from '../../../common/simpleAgreement';

const Agreement = () => {
  const { setRedirectUrl } = useCreditInfoStepsContext();

  return (
    <>
      <SimpleAgreement  setRedirectUrl={setRedirectUrl} serviceType = {SERVICE_TYPES.creditInfoForm} pathForRedirect={'/creditinfo'}/>
    </>
  )
};

export default Agreement;
